import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import './PremiumPrompt.css';

interface PremiumPromptProps {
  isOpen: boolean;
  onClose: () => void;
  feature: string;
  description: string;
}

const PremiumPrompt: React.FC<PremiumPromptProps> = ({ 
  isOpen, 
  onClose, 
  feature, 
  description 
}) => {
  const { theme } = useTheme();

  if (!isOpen) return null;

  return (
    <div className="premium-prompt-overlay" onClick={onClose}>
      <div 
        className="premium-prompt-modal" 
        onClick={(e) => e.stopPropagation()}
        style={{ 
          backgroundColor: theme.colors.surface,
          borderColor: theme.colors.primary 
        }}
      >
        <div className="premium-prompt-header">
          <h3 style={{ color: theme.colors.primary }}>🔒 Premium Feature</h3>
          <button 
            className="premium-prompt-close"
            onClick={onClose}
            style={{ color: theme.colors.textSecondary }}
          >
            ×
          </button>
        </div>
        
        <div className="premium-prompt-content">
          <div className="premium-prompt-icon">⭐</div>
          <h4 style={{ color: theme.colors.text }}>{feature}</h4>
          <p style={{ color: theme.colors.textSecondary }}>{description}</p>
          
          <div className="premium-prompt-benefits">
            <h5 style={{ color: theme.colors.text }}>What you'll get:</h5>
            <ul style={{ color: theme.colors.textSecondary }}>
              <li>Advanced video analysis with AI insights</li>
              <li>Detailed shot analysis and recommendations</li>
              <li>Personalized training plans</li>
              <li>Progress tracking and analytics</li>
              <li>Priority support</li>
            </ul>
          </div>
          
          <div className="premium-prompt-actions">
            <Link 
              to="/signup" 
              className="premium-prompt-signup"
              style={{ 
                backgroundColor: theme.colors.primary,
                color: 'white'
              }}
            >
              Sign Up for Premium
            </Link>
            <Link 
              to="/signin" 
              className="premium-prompt-signin"
              style={{ 
                color: theme.colors.primary,
                borderColor: theme.colors.primary
              }}
            >
              Already have an account? Sign In
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PremiumPrompt;
